import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/person/person-title.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-18f488fa"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrap person-wrap"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "wrap-title",
    src: _imports_0,
    alt: "",
    srcset: ""
  }, null, -1);
});
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h2", {
    class: "person-title"
  }, "请填写个人信息", -1);
});
var _hoisted_4 = {
  class: "ques-content"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "person-tips"
  }, "注：个人信息请如实填写", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Info_Input = _resolveComponent("Info-Input");
  var _component_ManyInput = _resolveComponent("ManyInput");
  var _component_City_Select = _resolveComponent("City-Select");
  var _component_Drop_Down_Box = _resolveComponent("Drop-Down-Box");
  var _component_Cascader = _resolveComponent("Cascader");
  var _component_Single_Choice = _resolveComponent("Single-Choice");
  var _component_Button = _resolveComponent("Button");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.personList, function (item, index) {
    return _openBlock(), _createElementBlock("ul", {
      class: "ques-item",
      key: item.title + index
    }, [item.questionType == 4 || item.questionType == 11 || item.questionType == 16 || item.questionType == 21 || item.questionType == 25 ? (_openBlock(), _createBlock(_component_Info_Input, {
      key: 0,
      quesIndex: index,
      showAnswerRequired: item.isRequired,
      data: item,
      onInputChange: $setup.handleRadioSelect
    }, null, 8, ["quesIndex", "showAnswerRequired", "data", "onInputChange"])) : item.questionType === 5 ? (_openBlock(), _createBlock(_component_ManyInput, {
      key: 1,
      onInputChange: $setup.hanldeManyInput,
      quesIndex: index,
      showAnswerRequired: item.isRequired,
      info: item
    }, null, 8, ["onInputChange", "quesIndex", "showAnswerRequired", "info"])) : item.questionType == 9 || item.questionType == 10 ? (_openBlock(), _createBlock(_component_City_Select, {
      key: 2,
      data: item,
      quesIndex: index,
      showAnswerRequired: item.isRequired,
      onSelectCity: $setup.handleSelectCity
    }, null, 8, ["data", "quesIndex", "showAnswerRequired", "onSelectCity"])) : item.questionType === 2 ? (_openBlock(), _createBlock(_component_Drop_Down_Box, {
      key: 3,
      showAnswerRequired: item.isRequired,
      quesIndex: index,
      data: item
    }, null, 8, ["showAnswerRequired", "quesIndex", "data"])) : item.questionType === 20 || item.questionType === 100 ? (_openBlock(), _createBlock(_component_Cascader, {
      key: 4,
      data: item,
      showAnswerRequired: item.isRequired,
      quesIndex: index,
      onCascaderChange: $setup.handleRadioSelect
    }, null, 8, ["data", "showAnswerRequired", "quesIndex", "onCascaderChange"])) : (_openBlock(), _createBlock(_component_Single_Choice, {
      key: 5,
      onRadioSelect: $setup.handleRadioSelect,
      quesIndex: index,
      showAnswerRequired: item.isRequired,
      data: item
    }, null, 8, ["onRadioSelect", "quesIndex", "showAnswerRequired", "data"]))]);
  }), 128)), _hoisted_5, _createVNode(_component_Button, {
    onClick: $setup.handleSubmitPersonInfo,
    class: "btn"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode("提交并下一步")];
    }),
    _: 1
  }, 8, ["onClick"])])]), _createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$emit('close');
    }),
    class: "mask"
  })], 64);
}